var map = {
	"./classic/views/Account.vue": [
		79277,
		9277
	],
	"./classic/views/Activation.vue": [
		72668,
		2668
	],
	"./classic/views/BuyNumber.vue": [
		84627,
		4627
	],
	"./classic/views/BuyNumberCountry.vue": [
		44384,
		4384
	],
	"./classic/views/BuyNumberCountryDid.vue": [
		20930,
		930
	],
	"./classic/views/CallDetailRecord.vue": [
		3400,
		3400
	],
	"./classic/views/Cart.vue": [
		67101,
		7101
	],
	"./classic/views/CustomerCare.vue": [
		23694,
		3694
	],
	"./classic/views/Dashboard.vue": [
		9687,
		9687
	],
	"./classic/views/Finance.vue": [
		95295,
		5295
	],
	"./classic/views/ForgotPassword.vue": [
		17987,
		7987
	],
	"./classic/views/Home.vue": [
		87070,
		7070
	],
	"./classic/views/Login.vue": [
		25942,
		5942
	],
	"./classic/views/MyModule.vue": [
		58565,
		8565
	],
	"./classic/views/MyNumber.vue": [
		65381,
		5381
	],
	"./classic/views/NotFound.vue": [
		36101,
		6101
	],
	"./classic/views/OrderResult.vue": [
		7863,
		7863
	],
	"./classic/views/ProjectSettings.vue": [
		77796,
		7796
	],
	"./classic/views/Rate.vue": [
		13253,
		3253
	],
	"./classic/views/Register.vue": [
		58749,
		648,
		8749
	],
	"./classic/views/ResetPassword.vue": [
		60982,
		982
	],
	"./classic/views/ServerError.vue": [
		8883,
		8883
	],
	"./classic/views/Sms.vue": [
		34156,
		4156
	],
	"./classic/views/Unsubscribe.vue": [
		21943,
		1943
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 71663;
module.exports = webpackAsyncContext;